import { Component, inject } from "@angular/core";
import { BaseComponent, SchabuIconButtonComponent, SchabuImageComponent, SchabuMenuComponent } from "@schabu/web.angular/components";
import { IMessageService, MessageService } from "@schabu/web.angular/services";
import { IconButtonComponentConfiguration, ImageComponentConfiguration, MenuComponentConfiguration } from "@schabu/web.core/builders";
import { MessageGroup, MessageType, State } from "@schabu/web.core/enumerations";
import { Action, Message, NavigationRequest, Stateable } from "@schabu/web.core/models";
import { ISchabuSdk, SchabuSdk } from "@schabu/web.sdk";
import { Page } from "enumerations/navigation/page.enum";
import { NavigationService } from "services/navigation/navigation.service";

@Component({
	imports: [
		SchabuIconButtonComponent,
		SchabuImageComponent,
		SchabuMenuComponent
	],
	selector: "sbu-header",
	templateUrl: "./header.component.html"
})
export class SchabuHeaderComponent extends BaseComponent {
	public backBtnConfig: IconButtonComponentConfiguration;
	public logoImgConfig: ImageComponentConfiguration;
	public menuConfig: MenuComponentConfiguration;
	protected menuState: Stateable<void>;
	protected messageService: IMessageService = inject(MessageService);
	protected navigationService: NavigationService = inject(NavigationService);
	protected schabuSdk: ISchabuSdk = inject(SchabuSdk);

	constructor() {
		super();

		const me: this = this;

		this.backBtnConfig = (new IconButtonComponentConfiguration.Builder()).withIcon("chevron_left")
																			 .onClick(Action.withAction(() => {
																				 me.back();
																			 }))
																			 .build();
		this.logoImgConfig = (new ImageComponentConfiguration.Builder()).withSource(this.LANGUAGE.translate("@@business-logo-source"))
																		.build();
		this.menuConfig = (new MenuComponentConfiguration.Builder()).withIcon("menu")
																	.withItems([
																		(new MenuComponentConfiguration.Builder()).withLabel("@@main-menu-dashboard-label")
																												  .onClick(Action.withAction(() => {
																													  me.navigateDashboard();
																												  }))
																												  .build(),
																		(new MenuComponentConfiguration.Builder()).withLabel("@@main-menu-jobs-label")
																												  .onClick(Action.withAction(() => {
																													  me.navigateJobs();
																												  }))
																												  .build(),
																		(new MenuComponentConfiguration.Builder()).withLabel("@@main-menu-team-label")
								.onClick(Action.withAction(() => {
									me.navigateTeam();
								}))
								.build(),
							// (new MenuComponentConfiguration.Builder()).withLabel("@@main-menu-profile-label")
																		// 										  .onClick(Action.withAction(() => {
																		// 											  me.navigateProfile();
																		// 										  }))
																		// 										  .build(),
																		(new MenuComponentConfiguration.Builder()).withLabel("@@main-menu-logout-label")
																												  .onClick(Action.withAction(() => {
																													  me.logout();
																												  }))
																												  .build()
																	])
																	.onClick(Action.withAction(() => {
																		me.toggleMenu();
																	}))
																	.build();
		this.menuState = new Stateable<void>(undefined);
	}

	public isAuthenticated(): boolean {
		return this.schabuSdk.user.isAuthenticated();
	}

	public onLogoClick(event: Event): void {
		this.hideMenu();
		
		let page: Page = Page.LOGIN;

		if (this.isAuthenticated()) {
			page = Page.DASHBOARD;
		}

		this.navigationService.navigate(new NavigationRequest<Page>(page));
	}

	protected override preDestroy(): void {}
	protected override postDestroy(): void {}
	protected override preInit(): void {}
	protected override postInit(): void {}

	protected async back(): Promise<void> {
		this.hideMenu();
		window.history.back();
	}

	protected async hideMenu(): Promise<void> {
		this.menuConfig.close?.trigger();
		this.menuState.clearState(State.PRESSED);
		this.messageService.send(new Message(MessageGroup.OVERLAY, MessageType.HIDE_OVERLAY));
	}

	protected async logout(): Promise<void> {
		this.hideMenu();
		this.navigationService.navigate(new NavigationRequest<Page>(Page.LOGOUT));
	}

	protected async navigateDashboard(): Promise<void> {
		this.hideMenu();
		this.navigationService.navigate(new NavigationRequest<Page>(Page.DASHBOARD));
	}

	protected async navigateJobs(): Promise<void> {
		this.hideMenu();
		this.navigationService.navigate(new NavigationRequest<Page>(Page.JOBS));
	}

	protected async navigateTeam(): Promise<void> {
		this.hideMenu();
		this.navigationService.navigate(new NavigationRequest<Page>(Page.TEAM));
	}

	protected async navigateProfile(): Promise<void> {
		this.hideMenu();
		this.navigationService.navigate(new NavigationRequest<Page>(Page.PROFILE));
	}

	protected async toggleMenu(): Promise<void> {
		if (this.menuState.hasState(State.PRESSED)) {
			this.hideMenu();
		}
		else {
			this.menuState.toggleState(State.PRESSED);
			this.messageService.send(new Message(MessageGroup.OVERLAY, MessageType.SHOW_OVERLAY));
		}
	}
}